import { render, staticRenderFns } from "./MyTutors.vue?vue&type=template&id=147bdd30&scoped=true&"
import script from "./MyTutors.vue?vue&type=script&lang=js&"
export * from "./MyTutors.vue?vue&type=script&lang=js&"
import style0 from "./MyTutors.vue?vue&type=style&index=0&id=147bdd30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147bdd30",
  null
  
)

export default component.exports